export interface ThemeClasses {
  bg: string;
  border: string;
  text: string;
  textSecondary: string;
  cardBg: string;
  cardBorder: string;
  buttonHover: string;
  buttonText: string;
  buttonTextHover: string;
}

export interface AlertState {
  show: boolean;
  title: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
}

/**
 * Opciones de selects. El `value` se guarda en backend y el `labelKey`
 * apunta a la traducción dentro de `resellerAdmin:integrators.options.*`.
 */
export const ADAPTER_OPTIONS = [
  { value: "recurso_confiable", labelKey: "options.adapter.recurso_confiable" },
  { value: "skyangel", labelKey: "options.adapter.skyangel" },
  { value: "fourkites", labelKey: "options.adapter.fourkites" },
] as const;

export const AUTH_STRATEGY_OPTIONS = [
  { value: "token-refresh", labelKey: "options.authStrategy.token-refresh" },
  { value: "basic", labelKey: "options.authStrategy.basic" },
] as const;

export const PROTOCOL_OPTIONS = [
  { value: "soap", labelKey: "options.protocol.soap" },
  { value: "rest", labelKey: "options.protocol.rest" },
  { value: "json", labelKey: "options.protocol.json" },
] as const;
